import type { ConfiguratorPoolSize } from './configuratorPoolSize.model'
import { z } from 'zod'

export const configuratorPoolSizeDtoSchema = z.object({
  id: z.number(),
  name: z.string(),
  size: z.string(),

})

export type ConfiguratorPoolSizeDto = z.infer<typeof configuratorPoolSizeDtoSchema>

export function transformConfiguratorPoolSizeDtoToConfiguratorPoolSize(configuratorPoolSizeDto: ConfiguratorPoolSizeDto): ConfiguratorPoolSize {
  return {
    id: configuratorPoolSizeDto.id,
    name: configuratorPoolSizeDto.name,
    size: configuratorPoolSizeDto.size,
  }
}
